export const FrTypes = [
  "Armchair Fundraiser (fundraising only)",
  "Student Enrichment Fundraiser",
  "Donation per Goal Achieved Fundraiser",
];
export const FrTypes2 = ["Armchair", "Enrichment", "PerGoal"];

export const FrStatus = ["Decline", "Pending", "Accepted"];

export const Titles = ["Mr.", "Ms.", "Mrs.", "Miss"];
